import {Box, Typography, styled} from '@mui/material';
import {DateCalendar} from '@mui/x-date-pickers';

const StyledDateCalendar = styled(DateCalendar)`
	margin: 0;
	width: 100%;

	.MuiPickersCalendarHeader-root {
		padding: 0;
		margin-top: 8px;
		margin-bottom: 16px;

		& .MuiPickersCalendarHeader-label {
			font-weight: 600;
			text-transform: capitalize;
		}

		& .MuiPickersArrowSwitcher-button {
			padding: 0;
		}

		& .MuiPickersArrowSwitcher-spacer {
			width: 48px;
		}
	}

	.MuiMonthCalendar-root,
	.MuiYearCalendar-root {
		width: 100%;
		display: grid;
		padding-left: 0px;
		grid-template-columns: repeat(4, 1fr);
		row-gap: 20px;
		column-gap: 10px;

		&::-webkit-scrollbar {
			width: 3px;
			background-color: ${({theme}) => theme.palette.grey[50]};
			position: absolute;
			right: 5px;
		}
		&::-webkit-scrollbar-thumb {
			border-radius: 8px;
			background-color: ${({theme}) => theme.palette.grey[400]};
		}
	}

	.MuiPickersMonth-root,
	.MuiPickersYear-root {
		flex-basis: calc(25% - 10px);
	}

	.MuiPickersMonth-monthButton,
	.MuiPickersYear-yearButton {
		text-transform: uppercase;
		border: 1px solid ${({theme}) => theme.palette.grey[400]};
		border-radius: 4px;
		height: 40px;
		min-width: 50px;
		width: 100%;
		margin: 0;

		&:disabled {
			border-color: ${({theme}) => theme.palette.action.disabled};
			color: ${({theme}) => theme.palette.action.disabled};
		}
	}
`;

const SelectedMonth = styled(Typography)`
	color: ${({theme}) => theme.palette.text.secondary};
	font-weight: 600;
	font-size: 1rem;
`;

const StyledBox = styled(Box)`
	display: flex;
	align-items: center;
	gap: 8px;

	${({theme}) => theme.breakpoints.down('sm')} {
		justify-content: space-between;
		flex: 1;
	}
`;

export {StyledDateCalendar, SelectedMonth, StyledBox};
